export const partners = [
  {
    name: "",
    link: "",
    logo: "/images/partners/dlf@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/hyatt@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/sibang@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/kate@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/okaya@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/indri@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/sibang@3x.webp",
  },
  {
    name: "",
    link: "",
    logo: "/images/partners/kate@3x.webp",
  },
];
